import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper, Typography } from '@mui/material';
import ReservationList from './reservation_list';
import ReservationSchedule from './reservation_schedule';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export default function ReservationMain({ restaurantId }) {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  if (!restaurantId) return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="textSecondary">Por favor selecciona un restaurante para ver sus reservas</Typography>
      </Box>
  );

  return (
    <Box sx={{ width: '100%', pt: 2 }}>
      <Paper elevation={0} sx={{ mb: 3, borderRadius: 2, border: '1px solid #e0e0e0', overflow: 'hidden' }}>
        <Tabs 
          value={tabIndex} 
          onChange={handleTabChange} 
          centered
          textColor="primary"
          indicatorColor="primary"
          sx={{
            bgcolor: '#fafafa',
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '1rem',
              py: 2,
              minWidth: 200,
            }
          }}
        >
          <Tab icon={<FormatListBulletedIcon />} iconPosition="start" label="Lista de Reservas" />
          <Tab icon={<CalendarMonthIcon />} iconPosition="start" label="Agenda / Gantt" />
        </Tabs>
      </Paper>
      
      <Box>
        {tabIndex === 0 && <ReservationList restaurantId={restaurantId} />}
        {tabIndex === 1 && <ReservationSchedule restaurantId={restaurantId} />}
      </Box>
    </Box>
  );
}
